import { useState, useMemo } from 'react';

export function useJobFilters(jobs) {
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    department: '',
    work_model: '',
    type: '',
    experience_level: '',
    state: '',
    city: ''
  });

  const filteredJobs = useMemo(() => {
    if (!Array.isArray(jobs)) return [];
    return jobs.filter(job => {
      const matchesSearch = job.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        job.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (job.job_code && job.job_code.toLowerCase().includes(searchQuery.toLowerCase()));

      const matchesDept = !filters.department || job.department === filters.department;
      const matchesModel = !filters.work_model || job.work_model === filters.work_model;
      const matchesType = !filters.type || job.type === filters.type;
      const matchesExp = !filters.experience_level || job.experience_level === filters.experience_level;
      
      const matchesState = !filters.state || 
        (job.location && job.location.toLowerCase().includes(filters.state.toLowerCase()));
      
      const matchesCity = !filters.city || 
        (job.location && job.location.toLowerCase().includes(filters.city.toLowerCase()));

      return matchesSearch && matchesDept && matchesModel && matchesType && matchesExp && matchesState && matchesCity;
    });
  }, [jobs, searchQuery, filters]);

  return {
    searchQuery,
    setSearchQuery,
    filters,
    setFilters,
    filteredJobs
  };
}
